import {
  getMediaBasePath,
  ImageWrapper,
  IStyles,
  pxToRem,
  pxTovW,
  ScoreProgressBar,
  theme,
} from '@geneo2-web/shared-ui';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useGlobalContext } from '../../app/Context/GlobalContextProvider';

const styles: IStyles = {
  header: {
    width: { xs: '100%', md: '100%', lg: '100%' },
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    alignItems: 'center',
  },
  headImage: {
    width: { xs: pxToRem(74), md: pxTovW(200), lg: pxTovW(124) },
    height: { xs: pxToRem(74), md: pxTovW(200), lg: pxTovW(124) },
    borderRadius: { xs: pxToRem(6), md: pxToRem(6), lg: pxTovW(15) },
    objectFit: 'cover',
  },
  headerData: {
    width: { xs: '100%', md: '100%' },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(14), md: pxTovW(15) },
  },
  title: {
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    wordWrap: 'break-word',
  },
  secondaryTitle: {
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    width: '90%',
  },
};

interface IProps {
  imagePath?: string;
  primaryTitle?: string;
  secondaryTitle?: string;
  progressBarScore?: number;
}

export const HeaderWithProgressBar = (props: IProps) => {
  const { imagePath, primaryTitle, secondaryTitle, progressBarScore } = props;
  const { isIpadOnly } = useGlobalContext();
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box sx={styles.header}>
      <ImageWrapper
        name="chapterImage"
        type="png"
        parentFolder="tempAssets"
        path={getMediaBasePath(imagePath, 'processedMediaBucket')}
        styles={styles.headImage}
      />

      <Box sx={styles.headerData}>
        <Box>
          <Typography variant="h1" sx={styles.title}>
            {primaryTitle}
          </Typography>
          <Typography
            variant={isIpadOnly ? 'h4' : 'button'}
            color="primary"
            fontWeight="regular"
            sx={styles.secondaryTitle}
          >
            {secondaryTitle}
          </Typography>
        </Box>

        {progressBarScore !== undefined ? (
          <Box sx={{ width: { xs: pxToRem(178), md: pxTovW(300) } }}>
            <ScoreProgressBar
              variant={largeScreen ? 'lg' : 'md'}
              score={progressBarScore}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
